import { OFFER_PREVIEW_HISTORY_ENTRY } from '../../constants/offerPreview';
import { selectIsMultipinsExpActive } from '../../selectors/experiments';
import { TFeature } from '../../types/map';
import { TThunkAction } from '../../types/redux';
import { hasModalHistoryEntry, openModalHistoryEntry, waitModalHistoryBack } from '../../utils/modalHistory';
import { closeOfferPreview } from '../closeOfferPreview/closeOfferPreview';
import { loadPreviewOffers } from '../previewOffers/loadPreviewOffers';
import { setMapOffer } from '../setMapOffer/setMapOffer';
import { markOfferAsViewed } from '../viewed/markOfferAsViewed';

export interface IOpenOfferPreviewDeps {
  isDetailed: boolean;
  /** Превью с записью в history - только на телефоне */
  isPhone: boolean;
  precision: number;
  /** Пин открыт и выбран. Что сделать в этот момент, решает вызывающий */
  onPinOpen?(feature: TFeature): void;
}

export function openOfferPreview(
  feature: TFeature,
  { isDetailed, isPhone, precision, onPinOpen }: IOpenOfferPreviewDeps,
): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const [offer] = feature.properties.offers;

    if (!offer?.realtyId) {
      context.logger.error('Не найден realtyId для открытия preview объявления', {
        domain: 'actions/features/openOfferPreview',
        featureId: feature.id,
      });

      return;
    }

    // popstate незавершённого шага назад закроет прежнее превью: ждём, чтобы он не попал на новое
    await waitModalHistoryBack();
    dispatch(setMapOffer({ realtyId: offer.realtyId, feature: { ...feature, precision } }));

    // Превью на телефоне: его «назад» закрывает превью; смена пина при открытом превью - запись та же
    if (isPhone && !hasModalHistoryEntry(OFFER_PREVIEW_HISTORY_ENTRY)) {
      openModalHistoryEntry(OFFER_PREVIEW_HISTORY_ENTRY, () => dispatch(closeOfferPreview()));
    }

    // Не ждём: превью покажет загрузку по своему статусу, ошибку loadPreviewOffers обработает сам.
    dispatch(loadPreviewOffers(feature.properties.offers.map(({ realtyId }) => realtyId)));

    onPinOpen?.(feature);

    // В эксперименте мультипинов просмотренность решает вызывающий, без него - отметка оффера на бэке
    if (selectIsMultipinsExpActive(getState())) {
      return;
    }

    if (!offer.isViewed && offer.cianId) {
      await dispatch(markOfferAsViewed({ cianId: offer.cianId, isDetailed }));
    }
  };
}
